import {Row} from './Row'
import {SkeletonAvatar, SkeletonBox, SkeletonText} from '@primer/react/experimental'

export function SkeletonRow() {
  return (
    <Row>
      <Row.LeadingVisual>
        <SkeletonAvatar />
      </Row.LeadingVisual>
      <SkeletonText size="bodyMedium" width={150} />
      <Row.Actions>
        <SkeletonBox height="32px" width="32px" />
      </Row.Actions>
    </Row>
  )
}
SkeletonRow.displayName = 'PanelList.SkeletonRow'
